/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useState, useEffect} from 'react';
import {Card, Col, Container, Row, Form} from 'react-bootstrap';
import Select, {type MultiValue} from 'react-select';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {variables} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import ImagePlaceHolder from 'assets/images/default-placeholder.jpg';
import moment from 'moment';
import customStyles from 'Common/customStyles';
import UserForm from 'pages/Users/UserForm';

interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

const ApprovedGuest = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.USERS;

  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editCategory, setEditCategory] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  const [sortColumn, setSortColumn] = useState('updated_at');
  console.log('🚀 ~ Festivals ~ setSortColumn:', setSortColumn);

  const [filter, setFilter] = useState<{
    utmSource: Array<{value: string; label: string}>;
    utmCampaign: Array<{value: string; label: string}>;
  }>({utmSource: [], utmCampaign: []});

  const mappedUtmSource = filter.utmSource.map((data: any): any => {
    return data.value;
  });
  const mappedUtmCampaign = filter.utmCampaign.map((data: any): any => {
    return data.value;
  });

  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);

  const [utmSource, setUtmSource] = useState([]);
  const [utmCampaign, setUtmCampaign] = useState([]);

  const [search, setSearch] = useState<string>('');

  const [sortDirection, setSortDirection] = useState('desc');
  console.log('🚀 ~ setSortDirection:', setSortDirection);

  const [categoryList, setCategoryList] = useState<CategoryItemType>();

  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);
  // const [resetSearchFlag, setResetSearchFlag] = useState(false);

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState('');
  const handleImageClick = (videoUrl: string): void => {
    setModalImageUrl(videoUrl);
    setIsImageModalOpen(true);
  };

  const closeModal = (): void => {
    setIsImageModalOpen(false);
    setModalImageUrl('');
  };
  useEffect(() => {
    ApiUtils.getApprovedGuestsList(
      `?type=user_approve_after_party&page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
      mappedUtmSource,
      mappedUtmCampaign,
    )
      .then(async (data: any): Promise<void> => {
        console.log('🚀 ~ .then ~ data:', data);
        setCategoryList(data as CategoryItemType);
        setTotalRecords(data?.total);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });

    setisStatusChange(false);
    setAllChecked(false);
  }, [
    pageValue,
    isEditCatergory,
    iseAddCategory,
    pageSize,
    search,
    isStatusChange,
    filter,
  ]);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };
  // const handleDeleteUser = async (id: any): Promise<void> => {
  //   const result = await Swal.fire({
  //     title: 'Are you sure?',
  //     html: `You won't be able to revert this!<br><br>`,
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, delete it!',
  //   });

  //   // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  //   if (result.isConfirmed) {
  //     ApiUtils.deleteUser(id)

  //       // eslint-disable-next-line unused-imports/no-unused-vars
  //       .then(async (data: any) => {
  //         await Swal.fire({
  //           title: 'Deleted',
  //           text: data?.message,
  //           icon: 'success',
  //         });
  //         ApiUtils.getApprovedGuestsList(
  //           `?type=user_approve_after_party&page=${pageValue}&page_size=${pageSize}`,
  //         )
  //           .then(data => {
  //             setCategoryList(data as CategoryItemType);
  //           })
  //           .catch((error: any) => {
  //             toast.error(error.message);
  //           });
  //       })
  //       .catch((error: any) => {
  //         void Swal.fire({
  //           title: 'Error!',
  //           text: error?.response?.data?.message,
  //           icon: 'error',
  //         });
  //       });
  //     setResetSearchFlag(true);
  //   }
  // };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  // const handleSortByColumn = (column: string): void => {
  //   let newSortDirection = 'asc';

  //   if (column === sortColumn) {
  //     newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
  //   } else {
  //     newSortDirection = 'desc';
  //   }
  //   ApiUtils.getCategoryList(
  //     `?page=${pageValue}&page_size=${pageSize}&sort_column=${column}&sort_direction=${newSortDirection}`,
  //   )
  //     .then(async (data: any): Promise<void> => {
  //       setCategoryList(data as CategoryItemType);
  //       setSortDirection(newSortDirection);
  //       setSortColumn(column);

  //       setTotalRecords((data as CategoryItemType)?.data?.total);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });
  // };
  // const toggleCategoryStatus = async (
  //   id: number,
  //   statusId: number,
  // ): Promise<void> => {
  //   // Function to toggle category status

  //   try {
  //     // Implement logic to toggle category status
  //     await ApiUtils.updateUserStatus({id, status: statusId});

  //     ApiUtils.getApprovedGuestsList(
  //       `?type=user_approve_after_party&page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
  //     )
  //       .then(async (data: any): Promise<void> => {
  //         toast.success('Status updated successfully !');
  //         setCategoryList(data as CategoryItemType);
  //         setTotalRecords(data?.total);
  //       })
  //       .catch((error: any) => {
  //         toast.error(error.message);
  //       });
  //   } catch (error) {
  //     console.error('Error toggling category status:', error);
  //   }
  // };

  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);

  // const handleSelectAll = (): void => {
  //   if (allChecked) {
  //     setAllChecked(false);
  //   } else {
  //     setAllChecked(true);
  //   }
  // };
  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  // const handleCheckboxChange = (productId: number): void => {
  //   let updatedSelectedProductIds: number[] = [];

  //   if (selectedProductIds.includes(productId)) {
  //     // Uncheck child, remove it from the array
  //     updatedSelectedProductIds = selectedProductIds.filter(
  //       id => id !== productId,
  //     );
  //   } else {
  //     // Check child, add it to the array
  //     updatedSelectedProductIds = [...selectedProductIds, productId];
  //   }

  //   setSelectedProductIds(updatedSelectedProductIds);
  // };

  // useEffect(() => {
  //   dispatch(setProductIds(selectedProductIds));
  //   if (selectedProductIds.length > 0) {
  //     setIsCheckboxChanged(true);
  //   } else {
  //     setIsCheckboxChanged(false);
  //   }
  // }, [selectedProductIds]);
  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected Festivals',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    // {
    //   id: 'parentBox', // Give the column a unique ID
    //   Header: () => (
    //     <input
    //       className="parentCheckbox"
    //       type="checkbox"
    //       checked={allChecked} // This binds the checked state to `allChecked`
    //       value="0"
    //       onChange={() => {
    //         // handleSelectAll();
    //       }}
    //     />
    //   ),
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: '',
    //   Cell: (cell: any) => {
    //     return (
    //       <div className="d-inline-flex align-items-center gap-3">
    //         <input
    //           className={
    //             selectedProductIds.includes(cell.row.original.id)
    //               ? 'checked-class'
    //               : 'unchecked-class'
    //           }
    //           value={cell.row.original.id}
    //           type="checkbox"
    //           checked={selectedProductIds.includes(cell.row.original.id)}
    //           onChange={() => {
    //             handleCheckboxChange(cell.row.original.id);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      Header: 'Image',
      disableFilters: true,
      filterable: true,
      accessor: 'image',
      Cell: (cell: any) => {
        return (
          <>
            <img
              height={50}
              width={50}
              src={cell?.value !== null ? cell?.value : ImagePlaceHolder}
              onClick={() =>
                cell?.value !== null && handleImageClick(cell.value)
              }
            />
          </>
        );
      },
    },
    {
      Header: 'Name',
      disableFilters: true,
      filterable: true,
      accessor: '',
      Cell: (cell: any) => {
        return (
          <>
            {cell?.row?.original?.first_name} {cell?.row?.original?.last_name}{' '}
            {Boolean(cell?.row?.original?.nick_name) && (
              <span>[{cell?.row?.original?.nick_name}]</span>
            )}
          </>
        );
      },
    },
    {
      Header: 'Email',
      disableFilters: true,
      filterable: true,
      accessor: 'email',
      Cell: (cell: any) => {
        return <>{cell?.value}</>;
      },
    },
    {
      Header: 'Phone',
      disableFilters: true,
      filterable: true,
      accessor: 'phone',
      Cell: (cell: any) => {
        return (
          <>
            +{cell?.row?.original?.country?.country_code}
            {cell?.value}
            <p style={{color: '#F6A32B', fontSize: '10px'}}>
              <b>{cell?.row?.original?.country?.name}</b>
            </p>
          </>
        );
      },
    },
    {
      Header: 'Gender',
      disableFilters: true,
      filterable: true,
      accessor: 'gender',
      Cell: (cell: any) => {
        return <>{cell?.value === 1 ? 'Male' : 'Female'}</>;
      },
    },
    {
      Header: 'Membership',
      disableFilters: true,
      filterable: true,
      accessor: 'memberShip_status',
      Cell: (cell: any) => {
        return (
          <>
            {variables.ACTIVE_STATUS_ID === parseInt(cell?.value)
              ? variables.ACTIVE_STATUS
              : variables.INACTIVE_STATUS}
          </>
        );
      },
    },
    {
      Header: 'User Type',
      disableFilters: true,
      filterable: true,
      accessor: 'type',
      Cell: (cell: any) => {
        let userType = '';
        switch (cell?.value) {
          case variables.UNKNOWN_USER_STATUS_ID:
            userType = variables.UNKNOWN_USER_STATUS;
            break;
          case variables.GUEST_USER_STATUS_ID:
            userType = variables.GUEST_USER_STATUS;
            break;
          case variables.INVITED_USER_STATUS_ID:
            userType = variables.INVITED_USER_STATUS;
            break;
          case variables.MEMBER_USER_STATUS_ID:
            userType = variables.MEMBER_USER_STATUS;
            break;
          case variables.MEMBERSHIP_EXPIRED_USER_STATUS_ID:
            userType = variables.MEMBERSHIP_EXPIRED_USER_STATUS;
            break;
          default:
            userType = '';
        }
        return userType;
      },
    },

    {
      Header: 'Instagram Profile',
      disableFilters: true,
      filterable: true,
      accessor: 'instagram_handle',
      Cell: (cellProps: any) => {
        return (
          <>
            {' '}
            <a
              href={`https://www.instagram.com/${cellProps?.value}`}
              target="_blank"
              rel="noreferrer">
              {cellProps?.value}
            </a>
          </>
        );
      },
    },
    // {
    //   Header: 'Party Per Week',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'party_per_week',
    //   Cell: (cell: any) => {
    //     return <>{cell?.value?.name}</>;
    //   },
    // },
    // {
    //   Header: 'How many invite',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'refer_user_count',
    //   Cell: (cell: any) => {
    //     return <>{cell?.value}</>;
    //   },
    // },
    {
      Header: 'Who invited',
      disableFilters: true,
      filterable: true,
      accessor: 'refer_own_user',
      Cell: (cell: any) => {
        return (
          <>
            {cell?.value?.first_name !== undefined
              ? cell?.value?.first_name
              : 'Puravida'}
          </>
        );
      },
    },
    // {
    //   Header: 'Event Attended',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'event_attended',
    //   Cell: (cell: any) => {
    //     return <>{cell?.value}</>;
    //   },
    // },
    // {
    //   Header: 'Venue Visited',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'venue_visited',
    //   Cell: (cell: any) => {
    //     return <>{cell?.value}</>;
    //   },
    // },
    // {
    //   Header: 'Activation Code',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'activation_code',
    //   Cell: (cell: any) => {
    //     return <>{cell?.value}</>;
    //   },
    // },
    {
      Header: 'Utm Source',
      disableFilters: true,
      filterable: true,
      accessor: 'utm_source',
      Cell: (cell: any) => {
        return <>{cell?.value}</>;
      },
    },
    {
      Header: 'Utm Campaign',
      disableFilters: true,
      filterable: true,
      accessor: 'utm_campaign',
      Cell: (cell: any) => {
        return <>{cell?.value}</>;
      },
    },
    {
      Header: 'Created At',
      disableFilters: true,
      filterable: true,
      accessor: 'created_at',
      Cell: (cellProps: any) => {
        return moment(cellProps?.value).format('Do MMM, YYYY hh:mm A');
      },
    },
    // {
    //   Header: 'Status',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: 'status',
    //   Cell: (cellProps: any) => {
    //     const toggleStatus = async (newStatusId: number): Promise<void> => {
    //       await toggleCategoryStatus(cellProps?.row?.original?.id, newStatusId);
    //     };
    //     return (
    //       <>
    //         <div className="switch">
    //           <input
    //             id={`switch-active-${cellProps?.row?.original?.id}`}
    //             name={`tripple-${cellProps?.row?.original?.id}`} // Unique name for each row
    //             type="radio"
    //             value={variables.ACTIVE_STATUS_ID}
    //             className="switch-input"
    //             checked={cellProps.value === variables.ACTIVE_STATUS_ID}
    //             onChange={async () =>
    //               await toggleStatus(variables.ACTIVE_STATUS_ID)
    //             } // Active status
    //           />
    //           <label
    //             htmlFor={`switch-active-${cellProps?.row?.original?.id}`}
    //             className={`switch-label switch-label-y`}>
    //             Active
    //           </label>

    //           <input
    //             id={`switch-inactive-${cellProps?.row?.original?.id}`}
    //             name={`tripple-${cellProps?.row?.original?.id}`} // Unique name for each row
    //             type="radio"
    //             value={variables.INACTIVE_STATUS_ID}
    //             className="switch-input"
    //             checked={cellProps.value === variables.INACTIVE_STATUS_ID}
    //             onChange={async () =>
    //               await toggleStatus(variables.INACTIVE_STATUS_ID)
    //             } // Inactive status
    //           />
    //           <label
    //             htmlFor={`switch-inactive-${cellProps?.row?.original?.id}`}
    //             className={`switch-label switch-label-i`}>
    //             Inactive
    //           </label>

    //           <input
    //             id={`switch-suspend-${cellProps?.row?.original?.id}`}
    //             name={`tripple-${cellProps?.row?.original?.id}`} // Unique name for each row
    //             type="radio"
    //             value={variables.SUSPEND_STATUS_ID}
    //             className="switch-input"
    //             checked={cellProps.value === variables.SUSPEND_STATUS_ID}
    //             onChange={async () =>
    //               await toggleStatus(variables.SUSPEND_STATUS_ID)
    //             } // Suspend status
    //           />
    //           <label
    //             htmlFor={`switch-suspend-${cellProps?.row?.original?.id}`}
    //             className={`switch-label switch-label-n`}>
    //             Suspend
    //           </label>

    //           <span className="switch-selector"></span>
    //         </div>
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: 'Action',
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: (cellProps: any) => {
    //     return (
    //       <Dropdown className="text-start">
    //         <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
    //           <i className="mdi mdi-dots-horizontal" />
    //         </Dropdown.Toggle>
    //         <Dropdown.Menu as="ul" className="dropdown-menu-end">
    //           <li>
    //             <Dropdown.Item
    //               onClick={() => {
    //                 setEditCategory(cellProps);
    //                 modalToggle();
    //               }}>
    //               <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
    //               Edit
    //             </Dropdown.Item>
    //           </li>
    //           <li>
    //             <Dropdown.Item
    //               onClick={async () => {
    //                 await handleDeleteUser(cellProps?.id);
    //               }}
    //               className="remove-list">
    //               <i className="ri-delete-bin-fill align-bottom me-2 text-muted" />
    //               Delete
    //             </Dropdown.Item>
    //           </li>
    //           <li>
    //             <Dropdown.Item
    //               onClick={async () => {
    //                 await handleSendActivation(cellProps?.id);
    //               }}
    //               className="remove-list">
    //               <i className="ri-send-plane-2-fill align-bottom me-2 text-muted" />
    //               Send activation code
    //             </Dropdown.Item>
    //           </li>
    //         </Dropdown.Menu>
    //       </Dropdown>
    //     );
    //   },
    // },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  // const handleSendActivation = async (id: any): Promise<void> => {
  //   try {
  //     const updateResponse: any = await ApiUtils.sendActivationCode({id});

  //     toast.success(updateResponse.message);
  //   } catch (error) {
  //     if (error instanceof Error) {
  //       // If the error is an instance of Error (like a network error), show its message
  //       toast.error(error.message);
  //     } else {
  //       // If it's of unknown type, display a generic error message
  //       toast.error('An unexpected error occurred.');
  //     }
  //   }
  // };

  const handleSelectUtmSourceChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setFilter(prev => ({
      ...prev,
      utmSource: [...selectedOptions],
    }));
  };

  const handleSelectUtmCampaignChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setFilter(prev => ({
      ...prev,
      utmCampaign: [...selectedOptions],
    }));
  };

  useEffect(() => {
    ApiUtils.getUtmSoucreList(`?type=utm_source`)
      .then(async (data: any): Promise<void> => {
        const mappedData = data?.data?.map((data: any) => {
          return {value: data, label: data};
        });
        setUtmSource(mappedData);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });

    ApiUtils.getUtmSoucreList(`?type=utm_campaign`)
      .then(async (data: any): Promise<void> => {
        const mappedData = data?.data?.map((data: any) => {
          return {value: data, label: data};
        });
        setUtmCampaign(mappedData);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
    // void fetchStatus();
    setisStatusChange(false);
    setAllChecked(false);
  }, []);

  console.log(
    'filter?.utmCampaign?',
    filter?.utmSource?.length !== 0 &&
      filter?.utmCampaign?.length !== 0 &&
      totalRecords !== 0
      ? totalRecords
      : 0,
  );
  useEffect(() => {
    if (filter.utmSource?.length === 0 && filter.utmCampaign?.length > 0) {
      setFilter(prev => ({
        ...prev,
        utmCampaign: [],
      }));
    }
  }, [filter.utmSource]);

  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Approved Guests</h4>
        </div>
        <div id="approved-users">
          <Row>
            <Col lg={3}>
              <div aria-labelledby="category-name-label" className="mb-3">
                <Form.Label id="category-name-label" htmlFor="category-name">
                  Utm Source
                </Form.Label>
                <Select
                  isMulti
                  className="custom-select"
                  id="utm-source"
                  name="utm-source"
                  value={filter.utmSource}
                  onChange={handleSelectUtmSourceChange}
                  styles={isDark ? customStyles : {}}
                  // styles={isDark ? colourStyles : {}}
                  options={utmSource}></Select>
              </div>
            </Col>
            <Col lg={3}>
              <div aria-labelledby="category-name-label" className="mb-3">
                <Form.Label id="category-name-label" htmlFor="category-name">
                  Utm Campaign
                </Form.Label>
                <Select
                  isDisabled={filter.utmSource?.length === 0}
                  isMulti
                  className="custom-select"
                  id="utm-campaign"
                  name="utm-campaign"
                  value={filter.utmCampaign}
                  onChange={handleSelectUtmCampaignChange}
                  styles={isDark ? customStyles : {}}
                  // styles={isDark ? colourStyles : {}}
                  options={utmCampaign}></Select>
              </div>
            </Col>
            {filter?.utmSource?.length !== 0 &&
              filter?.utmCampaign?.length !== 0 &&
              totalRecords !== 0 && (
                <Col lg={3} className="pt-4">
                  <div aria-labelledby="category-name-label" className="mb-3">
                    <Form.Label
                      id="category-name-label"
                      htmlFor="category-name">
                      <h4>Total :{totalRecords}</h4>
                    </Form.Label>
                  </div>
                </Col>
              )}
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    // isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search Festivals..."
                    buttonText="Add New User"
                    onClick={() => {
                      setEditCategory({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    // resetSearchFlag={resetSearchFlag}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={editCategory.id !== undefined ? 'Edit User' : 'Add User'}
          modalBody={
            <>
              <UserForm
                handleClose={modalToggle}
                editCategory={editCategory}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
              />
            </>
          }
        />
        <ModalContainer
          showModal={isImageModalOpen}
          handleClose={closeModal}
          modalTitle="User Image"
          size="md"
          isTemplate={true}
          modalBody={
            <>
              <img
                src={modalImageUrl}
                className="modal-image-preview"
                style={{height: '500px'}}
              />
            </>
          }
        />
      </Container>
    </div>
  );
};

export default ApprovedGuest;
